module.exports = __webpack_public_path__ + "fa-regular-400.99902ff08653f1e230f5.svg";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.svg
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.svg
// module chunks = styles